import { Col, Row } from "antd";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setDealerSlideShow } from "../../../reducers/authSlice";
import { ORG_TYPES, UNITS } from "../../Common/Constants";
import Chart from "react-apexcharts";
import { useRequiredAccess } from "../../../hooks/useRequiredAccess";

const DealerPerformance = () => {
  const dispatch = useDispatch();
  const checkAccess = useRequiredAccess([], [ORG_TYPES.DEALER]);

  useEffect(() => {
    checkAccess();
    dispatch(setDealerSlideShow(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const weeklyUnderMaintenanceData = {
    series: [
      {
        name: "Initial",
        data: [49, 43, 38, 40, 33],
      },
      {
        name: "Final",
        data: [44, 40, 30, 24, 28],
      },
    ],
    options: {
      chart: {
        type: "bar",
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "40%",
          endingShape: "rounded",
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: ["Squid", "Squid Pro", "EC2", "EC2 Pro", "EC3"],
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val;
          },
        },
      },
    },
  };

  return (
    <>
      <Row gutter={[16, 16]} className="dealer-service">
        <Col xs={24} sm={24} md={24} lg={12} xl={12}>
          <Row gutter={[16, 16]} className="h100">
            <Col span={24} className="serivce-status">
              <div className="dealer-card">
                <div className="dealer-card-head">
                  TOTAL DISTANCE TRAVELLED IN EACH MODEL
                </div>
                <div className="dealer-card-body p0">
                  <Row className="h100">
                    <Col span={24} className="mb05">
                      <div className="dealer-card-second-head mb05">
                        <Row gutter={[24, 16]}>
                          <Col span={12} className="justify-left">
                            Model
                          </Col>
                          <Col span={12} className="justify-left">
                            Distance
                          </Col>
                        </Row>
                      </div>
                      {[
                        {
                          model: "SQD",
                          distance: 3,
                        },
                        {
                          model: "SQD ULTRA",
                          distance: 3,
                        },
                        {
                          model: "SQD STAR",
                          distance: 6,
                        },
                      ].map((item, index) => {
                        return (
                          <Row key={index}>
                            <Col span={12} className="justify-left">
                              <div className="pdtb075 ml1">{item.model}</div>
                            </Col>
                            <Col span={12} className="justify-left">
                              <div className="pdtb075 ml1">
                                {item.distance} {UNITS.KM}
                              </div>
                            </Col>
                          </Row>
                        );
                      })}
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} xl={12}>
          <Row gutter={[16, 16]} className="h100">
            <Col span={24} className="serivce-status">
              <div className="dealer-card">
                <div className="dealer-card-head">
                  TOTAL DISTANCE TRAVELLED IN EACH MODES
                </div>
                <div className="dealer-card-body p0">
                  <Row className="h100">
                    <Col span={24} className="mb05">
                      <div className="dealer-card-second-head mb05">
                        <Row gutter={[24, 16]}>
                          <Col span={6} className="justify-left">
                            Model
                          </Col>
                          <Col span={6} className="justify-left">
                            ECO
                          </Col>
                          <Col span={6} className="justify-left">
                            CITY
                          </Col>
                          <Col span={6} className="justify-left">
                            POWER
                          </Col>
                        </Row>
                      </div>
                      {[
                        {
                          model: "SQD",
                          eco: 35,
                          city: 35,
                          power: 85,
                        },
                        {
                          model: "SQD ULTRA",
                          eco: 43,
                          city: 35,
                          power: 85,
                        },
                        {
                          model: "SQD STAR",
                          eco: 36,
                          city: 35,
                          power: 85,
                        },
                      ].map((item, index) => {
                        return (
                          <Row key={index}>
                            <Col span={6} className="justify-left">
                              <div className="pd075">{item.model}</div>
                            </Col>
                            <Col span={6} className="justify-left">
                              <div className="pd075">
                                {item.eco} {UNITS.KM}
                              </div>
                            </Col>
                            <Col span={6} className="justify-left">
                              <div className="pd075">
                                {item.city} {UNITS.KM}
                              </div>
                            </Col>
                            <Col span={6} className="justify-left">
                              <div className="pd075">
                                {item.power} {UNITS.KM}
                              </div>
                            </Col>
                          </Row>
                        );
                      })}
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row gutter={[16, 16]} className="mt1">
        <Col xs={24} sm={24} md={24} lg={12} xl={12}>
          <Row gutter={[16, 16]} className="h100">
            <Col span={24} className="serivce-status">
              <div className="dealer-card">
                <div className="dealer-card-head">
                  Weekly - Under Maintenance
                </div>
                <div className="dealer-card-body">
                  <Chart
                    options={weeklyUnderMaintenanceData.options}
                    series={weeklyUnderMaintenanceData.series}
                    type="bar"
                    width="100%"
                    height="220"
                  />
                </div>
              </div>
            </Col>
          </Row>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} xl={12}>
          <Row gutter={[16, 16]} className="h100">
            <Col span={24} className="serivce-status">
              <div className="dealer-card">
                <div className="dealer-card-head">
                  Monthly - Under Maintenance
                </div>
                <div className="dealer-card-body">
                  <Chart
                    options={weeklyUnderMaintenanceData.options}
                    series={weeklyUnderMaintenanceData.series}
                    type="bar"
                    width="100%"
                    height="220"
                  />
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default DealerPerformance;
